module.exports = __webpack_public_path__ + "img/robert-contact.8877acb3.png";